import React from 'react';
import classNames from 'classnames';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';

var Badge = function Badge(_ref) {
  var children = _ref.children,
      sizeLg = _ref.sizeLg,
      pill = _ref.pill,
      square = _ref.square,
      additionalClassName = _ref.additionalClassName,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? Variant.ivory : _ref$variant,
      textColor = _ref.textColor,
      text = _ref.text;

  var renderText = function renderText() {
    if (!text) {
      return null;
    }

    return /*#__PURE__*/React.createElement("span", {
      className: "ml-4p"
    }, text);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames("badge badge-".concat(variant), textColor, additionalClassName, {
      'badge-lg': sizeLg
    }, {
      'badge-pill': pill
    }, {
      'badge-square': square
    })
  }, children, renderText());
};

export { Badge };